// extracted by mini-css-extract-plugin
module.exports = {"techItem":"tech-item_techItem__2CfgZ","title":"tech-item_title__2bikW","movingLightText":"tech-item_movingLightText__xHSkL"};